import ButtonCollectionView from "../../../generic/button/collection";
import ButtonView from "../../../generic/button";

const DEFAULTS = {
  className: "action-wrapper btn-group",
  template: false,
  childView: ButtonView,
};

class Actions extends ButtonCollectionView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }
}

export { Actions as default };
